// @ts-expect-error Rollbar is imported via Rails, so we don't have all the types for it.
const Rollbar = global.Rollbar
const RollbarEnabled = !!Rollbar?.options?.accessToken

type Meta = Record<string, unknown>

const Logger = {
  info(msg: string, meta?: Meta) {
    console.info(msg, meta ?? '')
    if (RollbarEnabled) Rollbar.info(msg, meta)
  },
  warn(msg: string, meta?: Meta) {
    console.warn(msg, meta ?? '')
    if (RollbarEnabled) Rollbar.warning(msg, meta)
  },
  error(err: unknown, meta?: Meta) {
    // Accept Error or string
    if (err instanceof Error) {
      console.error(err, meta ?? '')
      if (RollbarEnabled) Rollbar.error(err, meta)
    } else {
      console.error(String(err), meta ?? '')
      if (RollbarEnabled) Rollbar.error(String(err), meta)
    }
  },
  // Optional: explicitly send non-errors
  event(event: string, meta?: Meta) {
    console.log(`[event] ${event}`, meta ?? '')
    if (RollbarEnabled) Rollbar.log(event, meta)
  },
}

export default Logger
